// src/core/features/feedback/api.ts
import { api } from "core/axios/axios";
import type { FeedbackRequest, FeedbackResponse } from "./types";

export async function submitFeedback(data: FeedbackRequest): Promise<FeedbackResponse> {
  const response = await api.post<FeedbackResponse>("feedback", data);
  return response.data;
}
